import { checkFont } from '@common/components/func';
import { ISelect } from '@common/types/element';
import { isEmpty, pick } from 'lodash';
import { Platform, StyleSheet } from 'react-native';

const createStyles = (attributes: ISelect, value: any) => {
  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        // 'borderWidth',
        'borderColor',
        'borderColor',
        'borderRadius',
        'backgroundColor',
        'opacity',
        'height',
      ]),
      // Override with style object properties if they exist
      ...(attributes.style?.borderColor && { borderColor: attributes.style.borderColor }),
      ...(attributes.style?.borderRadius !== undefined && { borderRadius: attributes.style.borderRadius }),
      ...(attributes.style?.backgroundColor && { backgroundColor: attributes.style.backgroundColor }),
      ...(attributes.style?.opacity !== undefined && { opacity: attributes.style.opacity }),
      ...(attributes.style?.height && { height: attributes.style.height }),
      ...(attributes.borderStyle !== 'none' && {
        borderWidth: attributes.style?.borderWidth || attributes.borderWidth,
      }),
      paddingHorizontal: attributes.style?.padding || 14,
      shadowColor: attributes?.shadow?.color || '#fff',
      shadowRadius: attributes?.shadow?.size || 0,
      shadowOpacity: attributes?.shadow?.blur || 0,
      shadowOffset: {
        width: attributes?.shadow?.x || 0,
        height: attributes?.shadow?.y || 0,
      },
      elevation: attributes?.shadow?.size || 0,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontFamily: attributes.style?.fontFamily || attributes?.fontFamily || 'Roboto',
      ...(!isEmpty(attributes.borderStyle) && {
        borderStyle:
          (attributes.style?.borderStyle || attributes.borderStyle) === 'none' 
            ? 'solid' 
            : (attributes.style?.borderStyle || attributes.borderStyle),
      }),
    },
    text: {
      color: !isEmpty(value)
        ? (attributes.style?.color || attributes?.color)
        : (attributes?.placeholderColor || attributes.style?.color || attributes?.color),
      fontSize: attributes.style?.fontSize || attributes.fontSize,

      ...(Platform.OS !== 'web' && {
        fontFamily: checkFont(attributes.style?.fontFamily || attributes?.fontFamily),
      }),
      lineHeight:
        Platform.OS === 'web' ? undefined : (attributes.style?.fontSize || attributes.fontSize) * 1.15,
      flex: 1,
    },
  });
};

export default createStyles;
